import type React from 'react';
import { hasInstanceMarker, splitLeadingInstanceMarker } from '../portal/instanceMarker';
import { InstanceBadge } from './InstanceBadge';
import { InstanceMarkerText } from './InstanceMarkerText';

/**
 * A value that opens on a deployment, badged: `(id)a12 — Warning Alerts` reads as the badge and
 * then the rest. Anywhere a node fits, this is how a deployment is shown.
 */
export const InstanceValue: React.FC<{ value: string }> = ({ value }) => {
  const instance = splitLeadingInstanceMarker(value);
  if (instance) {
    return (
      <>
        <InstanceBadge id={instance.id} />
        {instance.rest}
      </>
    );
  }

  // Mentioned mid-value rather than opening it: nothing to badge, but the id still has to go.
  return hasInstanceMarker(value) ? <InstanceMarkerText text={value} /> : <>{value}</>;
};
